import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import classNames from 'classnames';
import Leaves from './Leaves';
import Financials from './Financials';
import { ProjectContrib } from './ProjectContrib';

// Activity is a single page; the sections below are switched via sub-tabs and
// addressable at /activity/<tab>. Each section is rendered "embedded" so it
// drops its own page heading (the tab strip is the header here).
const TABS = [
    { key: 'leaves', label: 'Leaves', render: () => <Leaves embedded /> },
    { key: 'contrib', label: 'Contributions', render: () => <ProjectContrib embedded /> },
    { key: 'utilisation', label: 'Utilisation', render: () => <Financials embedded /> },
];

const Activity = () => {
    const { tab } = useParams();
    const [sp] = useSearchParams();
    const qs = sp.toString();
    const current = TABS.some(t => t.key === tab) ? tab : 'leaves';
    const active = TABS.find(t => t.key === current);

    return (
        <div>
            <div className="page-head" style={{ justifyContent: 'space-between' }}>
                <h2>Activity</h2>
                <div className="ds-tabs" role="tablist" aria-label="Activity sections">
                    {TABS.map(t => (
                        <Link
                            key={t.key}
                            to={`/activity/${t.key}${qs ? `?${qs}` : ''}`}
                            role="tab"
                            aria-selected={current === t.key}
                            className={classNames('ds-tab', { 'is-active': current === t.key })}
                        >
                            {t.label}
                        </Link>
                    ))}
                </div>
            </div>
            {active.render()}
        </div>
    );
};

export default Activity;
